import { SVGProps } from "react";

export const TeamManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8661 17.25H18.3563C19.5061 17.25 20.4207 16.7261 21.2419 15.9936C23.328 14.1326 18.4241 12.25 16.75 12.25M14.75 2.31877C14.9771 2.27373 15.2129 2.25 15.4548 2.25C17.2747 2.25 18.75 3.59315 18.75 5.25C18.75 6.90685 17.2747 8.25 15.4548 8.25C15.2129 8.25 14.9771 8.22627 14.75 8.18123"
      stroke={props.stroke || "#1A1C1F"}
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M3.73131 13.3612C2.55234 13.993 -0.538863 15.2831 1.34388 16.8974C2.26359 17.686 3.28791 18.25 4.57572 18.25H11.9243C13.2121 18.25 14.2364 17.686 15.1561 16.8974C17.0389 15.2831 13.9477 13.993 12.7687 13.3612C10.004 11.8796 6.49599 11.8796 3.73131 13.3612Z"
      stroke-width="1.5"
      stroke={props.stroke || "#1A1C1F"}
    />
    <path
      d="M12.25 4.75C12.25 6.95914 10.4591 8.75 8.25 8.75C6.04086 8.75 4.25 6.95914 4.25 4.75C4.25 2.54086 6.04086 0.75 8.25 0.75C10.4591 0.75 12.25 2.54086 12.25 4.75Z"
      stroke={props.stroke || "#1A1C1F"}
      stroke-width="1.5"
    />
  </svg>
);
